module.exports = __webpack_public_path__ + "static/media/logo.93bd8dce.png";